<template>
  <aside class="global-sticky-top-banner" aria-label="Project Repository Banner">
    <div class="banner-inner">
      <span class="banner-tag">开源仓库</span>
      <p class="banner-text">
        获取网站源码，请访问：
        <a
          href="https://github.com/softwarelink-net/26-fatigue-bid"
          target="_blank"
          rel="noopener noreferrer"
          class="repo-anchor"
        >
          https://github.com/softwarelink-net/26-fatigue-bid
        </a>
      </p>
    </div>
  </aside>
</template>

<style scoped>
.global-sticky-top-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  z-index: 9999;
  background: linear-gradient(90deg, #090d16 0%, #1e293b 100%);
  border-bottom: 1px solid #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.banner-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #e2e8f0;
}

.banner-text {
  margin: 0;
}

.banner-tag {
  background: #2563eb;
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.repo-anchor {
  color: #38bdf8;
  font-weight: 500;
  text-decoration: underline;
  transition: color 0.15s ease;
}

.repo-anchor:hover {
  color: #7dd3fc;
}
</style>
